import React, { useState } from "react"
import { Box } from "@mui/system"
import ButtonWithIcon from "src/v2/components/Button/Button"
import PropTypes from "prop-types"
import { ReactComponent as TableBaseIcon } from "src/v2/assets/icons/table-base-icon.svg"
import TableFincsMarketData from "src/pages/emissao/tab/table/table_fincs_marketdata"
import { Grid, ThemeProvider } from "@mui/material"
import ModalDialogPage from "src/components/modal-dialog"
import theme from "src/utils/theme"
import TableEmissaoLTV from "src/pages/emissao/tab/table/table_emissao_ltv"
import TableEmissaoCaracteristicas from "src/pages/emissao/tab/table/table_emissao_caracteristicas"

const ButtonIcon = ({ label, onClick }) => (
    <ButtonWithIcon icon={<TableBaseIcon />} onClick={onClick}>
        {label}
    </ButtonWithIcon>
)

ButtonIcon.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
}

export const BoxCreditEmissionButtonGroupAdmin = ({
    cetipIsin,
    callBackSetIsLoading,
}) => {
    const [openTableModal, setOpenTableModal] = useState({
        open: false,
        title: "",
        component: <></>,
    })

    const handleClickFincs = () => {
        const value = (cetipIsin || "").toString().trim().toUpperCase()
        const isISIN = /^[A-Z]{2}[A-Z0-9]{9}[0-9]$/i.test(value)

        setOpenTableModal({
            open: true,
            title: "FINCS MarketData",
            component: (
                <TableFincsMarketData
                    loading={callBackSetIsLoading}
                    cetipIsin={{
                        CETIP: isISIN ? "" : value,
                        ISIN: isISIN ? value : ""
                    }}
                />
            ),
        })
    }
    const handleClickCharactersEmission = () => {
        setOpenTableModal({
            open: true,
            title: "Emissão Característica",
            component: (
                <TableEmissaoCaracteristicas
                    loading={callBackSetIsLoading}
                    cetipIsin={cetipIsin}
                />
            ),
        })
    }

    const handleClickLtvEmission = () => {
        setOpenTableModal({
            open: true,
            title: "Emissão LTV",
            component: (
                <TableEmissaoLTV
                    loading={callBackSetIsLoading}
                    cetipIsin={cetipIsin}
                />
            ),
        })
    }

    return (
        <div>
            <ThemeProvider theme={theme}>
                <ModalDialogPage
                    open={openTableModal.open}
                    title={openTableModal.title}
                    close={() => {
                        setOpenTableModal({
                            open: false,
                            component: null,
                            title: null,
                        })
                    }}
                >
                    <>
                        <Grid container direction="column">
                            <Grid item xs={12} md={12} xl={12}>
                                {openTableModal.component}
                            </Grid>
                        </Grid>
                    </>
                </ModalDialogPage>
            </ThemeProvider>
            <Box display="flex" gap={3} flexDirection="column">
                <Box
                    display="flex"
                    flexDirection={{ xxxs: "column", xs: "row" }}
                    flexWrap={{ xs: "wrap", md: "nowrap" }}
                    columnGap={{ xxxs: 3 }}
                    rowGap={{ xxxs: 2, md: 0 }}
                >
                    <ButtonIcon
                        label="FINCS MARKETDATA"

                        onClick={() => {
                            handleClickFincs()
                        }}
                    />
                    <ButtonIcon
                        label="EMISSÃO CARACTERISTICA"
                        onClick={handleClickCharactersEmission}
                    />
                    <ButtonIcon
                        label="EMISSÃO LTV"
                        onClick={handleClickLtvEmission}
                    />
                </Box>
            </Box>
        </div>
    )
}

BoxCreditEmissionButtonGroupAdmin.propTypes = {
    cetipIsin: PropTypes.string.isRequired,
    callBackSetIsLoading: PropTypes.func,
}
